// `surplusses` is validated `required_without:stuffed` server-side, so an
// absent key correctly triggers the `without` branch. Sending [] risks
// failing `required` instead. Empty arrays are therefore omitted.
export const buildRequestPayload = ({ userId, surplusses, stuffed }) => {
  const payload = { userId };
  if (surplusses && surplusses.length > 0) {
    payload.surplusses = surplusses;
  }
  if (stuffed && stuffed.length > 0) {
    payload.stuffed = stuffed;
  }
  return payload;
};
